import MicroModal from 'micromodal'; 

export default MicroModal.init();